import { render, staticRenderFns } from "./BrowsePage.vue?vue&type=template&id=1ad351b8&"
import script from "./BrowsePage.vue?vue&type=script&lang=js&"
export * from "./BrowsePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "bf55a316"
  
)

export default component.exports